import axios from 'axios';
import React from 'react';
import { connect } from 'react-redux';
import * as actionCreators from '../../store/actions/mainLayoutActions';
import DeleteIcon from '../../assets/icons/icon-close-black.svg';
import { IsListEmpty } from '../../utilities/CommonMethods';
import ShowLoader from '../../hoc/ShowLoader/ShowLoader';

import classes from './CustomerSupport.module.css';

class CustomerSupport extends React.Component {

    state = {
        filesArray: [],
        currentFilesCount: 0,
        formIsValid: false,
        showMaxFilesMessage: false,
        showLoader: false
    }



    setDependent = () => {

    }

    // zsOpenFileBrowseAttachment = (event) => {

    // }
    onRemoveFileClicked = (pos) => {
        let updatedFilesArray = [...this.state.filesArray];
        updatedFilesArray.splice(pos, 1);
        this.setState({ filesArray: updatedFilesArray, showMaxFilesMessage: false });
    }

    zsRenderBrowseFileAttachment = (event) => {
        // console.log('File Selected => ', event)
        let updatedFilesArray = [...this.state.filesArray];
        let updatedCurrentFilesCount = this.state.currentFilesCount + 1;
        event.preventDefault();
        const fileSize = event.target.files[0].size / (1024 * 1024);
        if (fileSize > 20) {
            this.props.onFailureDialogShow('Maximum allowed file size is 20 MB', 'OKAY');
        } else {
            if (updatedFilesArray.length < 5) {
                // console.log('GO forward', updatedFilesArray.length, event, event.target.value);
                var zsFileName = '';
                if ((event.target.value.indexOf('\\') > -1)) {
                    var zsAttachmentDataSplits = event.target.value.split('\\');
                    var zsAttachmentDataSplitsLen = zsAttachmentDataSplits.length;
                    zsFileName = zsAttachmentDataSplits[zsAttachmentDataSplitsLen - 1];
                } else {
                    zsFileName = event.target.value;
                }

                var extension = zsFileName.split('.').pop().toLowerCase();
                var unSupportedExtensions = ["ade", "adp", "apk", "appx", "appxbundle", "bat", "cab", "cer", "chm", "cmd", "com", "cpl", "dll", "dmg", "exe", "hlp", "hta", "ins", "iso", "isp", "jar", "js", "jse", "lib", "lnk", "mde", "msc", "msi", "msix", "msixbundle", "msp", "mst", "nsh", "pif", "ps1", "pst", "reg", "scr", "sct", "shb", "sys", "tmp", "url", "vb", "vbe", "vbs", "vxd", "wsc", "wsf", "wsh", "terminal"];

                if (unSupportedExtensions.indexOf(extension) != -1) {
                    this.props.onFailureDialogShow("The file wasn't attached since its extension is not supported.", 'OKAY');
                    return;
                } else {
                    updatedFilesArray.push({
                        fileName: zsFileName,
                        value: event.target.value,
                        file: event.target.files[0]
                    });
                    // console.log('Updated Array => ', updatedFilesArray)
                    this.setState({ filesArray: updatedFilesArray, currentFilesCount: updatedCurrentFilesCount, showMaxFilesMessage: false });
                }

            } else {
                event.preventDefault();
                // console.log('Already Present. Block');
                this.setState({ showMaxFilesMessage: true });
            }
        }
    }

    zsValidateMandatoryFields = (e) => {
        e.preventDefault();

        var zsWebFormMandatoryFields = new Array("Contact Name", "Email", "Phone", "Subject", "Classification");
        var zsFieldsDisplayLabelArray = new Array("Name", "Email", "Mobile", "Subject", "Category");

        // let name = '', email = '', mobile = '', program = '', status = true, paymentAmount = 550;

        // const form = document.forms['WebToLeads4321335000000362001'];

        var name = '', email = '', isError = 0;
        for (var index = 0; index < zsWebFormMandatoryFields.length; index++) {
            isError = 0;

            var fieldObject = document.forms['zsWebToCase_463162000005738009'][zsWebFormMandatoryFields[index]];
            if (fieldObject) {
                if (((fieldObject.value).replace(/^\s+|\s+$/g, '')).length == 0) {
                    alert(zsFieldsDisplayLabelArray[index] + ' cannot be empty ');
                    fieldObject.focus();
                    isError = 1;
                    return false;
                } else {
                    if (fieldObject.name == 'Email') {
                        const emailRegex = /^([\w_][\w\-_.+\'&]*)@(?=.{4,256}$)(([\w]+)([\-_]*[\w])*[\.])+[a-zA-Z]{2,22}$/;
                        if (!fieldObject.value.match(emailRegex)) {
                            isError = 1;
                            alert('Enter a valid Email id');
                            fieldObject.focus();
                            e.preventDefault();
                            break;
                        }
                    }
                }
                if (fieldObject.nodeName == 'SELECT') {
                    if (fieldObject.options[fieldObject.selectedIndex].value == 'None') {
                        alert(zsFieldsDisplayLabelArray[index] + ' cannot be None');
                        fieldObject.focus();
                        isError = 1;
                        e.preventDefault();
                        break;
                    }
                }
                if (fieldObject.type == 'checkbox') {
                    if (fieldObject.checked == false) {
                        alert('Please accept ' + zsFieldsDisplayLabelArray[index]);
                        fieldObject.focus();
                        isError = 1;
                        e.preventDefault();
                        break;
                    }
                }
                if (fieldObject.name == 'Classification') {
                    if (fieldObject.options[fieldObject.selectedIndex].value == 'None') {
                        alert(zsFieldsDisplayLabelArray[index] + ' cannot be None');
                        fieldObject.focus();
                        isError = 1;
                        e.preventDefault();
                        break;
                    }
                }
            }
        }
        if (isError == 0) {
            this.setState({ showLoader: true });
            const form = document.forms['zsWebToCase_463162000005738009'];
            let formData = new FormData();
            for (var i = 0; i < form.childElementCount - 1; i++) {
                var field_name = form.childNodes[i].name,
                    field_value = form.childNodes[i].value;
                formData.append(field_name, field_value);
            }

            for (var i = 1; i < 8; i++) { //8 because 8 fields. Need to increment/decrement accordingly
                var field_name = form.childNodes[5].rows[i].cells[1].firstElementChild.name,
                    field_value = form.childNodes[5].rows[i].cells[1].firstElementChild.value;

                formData.append(field_name, field_value);
                // console.log('Form values => ', field_name, field_value);
            }

            if (!IsListEmpty(this.state.filesArray)) {
                for (var j = 0; j < this.state.filesArray.length; j++) {
                    formData.append('attachment_' + (j + 1), this.state.filesArray[j].file);
                }
            }

            axios.post('https://desk.zoho.com/support/WebToCase', formData)
                .then((response) => {
                    // console.log('Contact Support Form Submitted Successfully! >>> ', response);
                    this.props.onSuccessDialogShow('Thank you! We have received your query. We will get back to you within 24 hours.', 'OKAY');
                    this.setState({ showLoader: false, filesArray: [] });
                }).catch((error) => {
                    // console.log('Contact Support Form Submission failed! >>>', error);
                    this.props.onSuccessDialogShow('Thank you! We have received your query. We will get back to you within 24 hours.', 'OKAY');
                    this.setState({ showLoader: false, filesArray: [] });
                });
            this.moveToTop();

            // setTimeout(() => {
            //     this.props.onSuccessDialogShow('Thank you! We have received your query. We will get back to you within 24 hours.', 'OKAY');
            //     this.setState({ showLoader: false });
            // }, 1500);


        } else {
            this.setState({ formIsValid: false });
        }
    }

    moveToTop = () => {
        setTimeout(function () {
            document.body.scrollTop = 0; // For Safari
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
        }, 1);
    }

    componentDidMount() {
        this.props.setupProgramDetailsTopbar(false, false, false);
        this.props.setTopbarTheme('Light');
        this.moveToTop();
    }

    render() {
        return (
            <div className={[classes.CustomerSupportPageContainer, this.props.userLoggedIn ? classes.RemoveTopMargin : ''].join(' ')}>
                <div id='zohoSupportWebToCase' className={classes.WrapperDiv}>
                    {
                        this.state.showLoader
                            ? <div className={classes.LoaderContainer}>
                                <ShowLoader isLoading={true} transparentBg={true} />
                            </div>
                            : <form name='zsWebToCase_463162000005738009'
                                id='zsWebToCase_463162000005738009'
                                // action='https://desk.zoho.com/support/WebToCase'
                                method='POST'
                                onSubmit={this.zsValidateMandatoryFields}
                                encType='multipart/form-data' >

                                <input type='hidden' name='xnQsjsdp' value='lDBpiZrQivwHNNhSsQ1qxg$$' readOnly={true} />
                                <input type='hidden' name='xmIwtLD' value='BNEEU45BYvE5q11yAwQFwIIjjEL9B-pv' readOnly={true} />
                                <input type='hidden' name='xJdfEaS' defaultValue='' readOnly={true} />
                                <input type='hidden' name='actionType' value='Q2FzZXM=' readOnly={true} />
                                {/* <input type="hidden" id="property(module)" value="Cases" readOnly={true} />
                            <input type="hidden" id="dependent_field_values_Cases" */}
                                {/* value="&#x7b;&quot;JSON_VALUES&quot;&#x3a;&#x7b;&#x7d;,&quot;JSON_SELECT_VALUES&quot;&#x3a;&#x7b;&#x7d;,&quot;JSON_MAP_DEP_LABELS&quot;&#x3a;&#x5b;&#x5d;&#x7d;" readOnly={true} /> */}
                                <input type='hidden' name='returnURL' value='https&#x3a;&#x2f;&#x2f;classroom.edyoda.com&#x2f;contact-us'
                                    readOnly={true} />

                                <table border='0' cellSpacing='0' className={classes.Table}>
                                    <tbody>
                                        <tr>
                                            <td colSpan='2' className={classes.FormHeading}>
                                                <p> <strong>Customer Support</strong></p>
                                            </td>
                                        </tr>
                                        <tr className={classes.TableRow}>
                                            <td className={classes.FieldName} align='left'>Name<span className={classes.Red}>*</span></td>
                                            <td align='left'>
                                                <input type='text' maxLength='120' name='Contact Name'
                                                    className={classes.InputBox} />
                                            </td>
                                        </tr>
                                        <tr className={classes.TableRow}>
                                            <td className={classes.FieldName} align='left'>Email<span className={classes.Red}>*</span></td>
                                            <td align='left'>
                                                <input type='text' maxLength='120' name='Email' defaultValue=''
                                                    className={classes.InputBox} />
                                            </td>
                                        </tr>
                                        <tr className={classes.TableRow}>
                                            <td className={classes.FieldName} align='left'>Mobile<span className={classes.Red}>*</span></td>
                                            <td align='left'>
                                                <input type='text' maxLength='120' name='Phone' defaultValue=''
                                                    className={classes.InputBox} />
                                            </td>
                                        </tr>
                                        <tr className={classes.TableRow}>
                                            <td className={classes.FieldName} align='left'>Subject<span className={classes.Red}>*</span></td>
                                            <td align='left'>
                                                <input type='text' maxLength='255' name='Subject' defaultValue=''
                                                    className={classes.InputBox} />
                                            </td>
                                        </tr>
                                        {/* <tr className={classes.TableRow}>
                                            <td className={classes.FieldName} align='left'>Batch<span className={classes.Red}>*</span></td>
                                            <td align='left'>
                                                <select name='Batch' defaultValue='' className={classes.InputBox}
                                                    onChange={() => this.setDependent(this, false)} id='CASECF1'>
                                                    <option defaultValue=''>None</option>

                                                    {
                                                        !IsListEmpty(this.props.programsList)
                                                            ? this.props.programsList.length === 1
                                                                ? <option key={this.props.programsList[0].programBatchCode}
                                                                    value={this.props.programsList[0].programBatchCode}
                                                                    selected={true}>
                                                                    {this.props.programsList[0].programBatchCode}
                                                                </option>
                                                                : this.props.programsList.map((program) => {
                                                                    return (
                                                                        <option key={program.programBatchCode}
                                                                            value={program.programBatchCode}>
                                                                            {program.programBatchCode}
                                                                        </option>
                                                                    );
                                                                })
                                                            : null
                                                    }
                                                </select>
                                            </td>
                                        </tr> */}
                                        <tr className={classes.TableRow}>
                                            <td className={classes.FieldName} align='left'>Category<span className={classes.Red}>*</span></td>
                                            <td align='left'>
                                                <select name='Classification' defaultValue='' className={classes.InputBox}
                                                    onChange={() => this.setDependent(this, false)} id='Classification'>
                                                    <option value='None'>None</option>
                                                    <option value='Payment and ISA'>Payment and ISA</option>
                                                    <option value='Placements'>Placements</option>
                                                    <option value='Certification'>Certification</option>
                                                    <option value='Platform and Tools'>Platform and Tools</option>
                                                    <option value='Live sessions'>Live sessions</option>
                                                    <option value='Session Doubts'>Session Doubts</option>
                                                    <option value='Attendance Query'>Attendance Query</option>
                                                </select>
                                            </td>
                                        </tr>
                                        <tr className={classes.TableRow}>
                                            <td className={classes.FieldName} align='left'>Description<span className={classes.Red}>*</span></td>
                                            <td align='left'>
                                                <textarea name='Description' maxLength='3000' style={{ minHeight: '100px' }} className={classes.InputBox}></textarea>
                                            </td>
                                        </tr>
                                        <tr className={classes.TableRow}>
                                            <td className={classes.FieldName} align='left'>Attachment &nbsp;&nbsp;</td>
                                            <td align='left' className={classes.AddHeight}>
                                                <input className={classes.FileInput} type='file' name='attachment_1' id='zsattachment_1'
                                                    // onClick={this.zsOpenFileBrowseAttachment}
                                                    onChange={(event) => this.zsRenderBrowseFileAttachment(event)} />

                                                {
                                                    this.state.filesArray.length < 5
                                                        ? <label htmlFor="zsattachment_1" className={[classes.FieldName, classes.Label].join(' ')} id="zsBrowseAttachment">
                                                            Attach Files </label>
                                                        : null
                                                }

                                                <span id='zsMaxSizeMessage' className={classes.MessageFileSize}>
                                                    Each of your file(s) can be up to 20MB in size.</span>

                                                <div id='zsFileBrowseAttachments'></div>
                                                <div className={classes.FilesList}>
                                                    {
                                                        this.state.filesArray.length !== 0
                                                            ? this.state.filesArray.map((file, index) => {
                                                                // console.log('Mapping now')
                                                                return <p key={index} className={classes.AttachedFileName}>{file.fileName}
                                                                    {/* <span onClick={() => this.onRemoveFileClicked(index)}> X </span> */}
                                                                    <img src={DeleteIcon} className={classes.DeleteIcon} onClick={() => this.onRemoveFileClicked(index)} alt="remove attached file" title="Remove attached file" />
                                                                </p>
                                                            })
                                                            : null
                                                    }
                                                </div>
                                                {
                                                    this.state.showMaxFilesMessage
                                                        ? <p id='zsMaxLimitMessage' className={classes.MaxFilesMessage}>
                                                            You can attach as many as 5 files at a time.</p>
                                                        : null
                                                }
                                            </td>
                                        </tr>
                                        <tr className={classes.TableRow}>
                                            <td colSpan='2' align='center'>
                                                <input type='submit' id="zsSubmitButton_463162000005738009" className={classes.SubmitButton} value='SUBMIT' />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </form>
                    }
                </div >
            </div >
        );
    }
}

const mapStateToProps = state => {
    return {
        activeProgramBatchCode: state.activeProgramBatchCode,
        activeModuleName: state.activeModuleName,
        programsList: state.enrolledProgramsList,
        userLoggedIn: state.userLoggedIn,

        showSuccessDialog: state.showSuccessDialog,
        successDialogMessage: state.successDialogMessage,
        successDialogButtonLabel: state.successDialogButtonLabel,
        showFailureDialog: state.showFailureDialog,
        failureDialogMessage: state.failureDialogMessage,
        failureDialogButtonLabel: state.failureDialogButtonLabel,
        somethingWentWrong: state.somethingWentWrong,
        notFound: state.notFound,
        unauthorized: state.unauthorized,
    }
}

const mapDisptachToProps = dispatch => {
    return {
        setTopbarTheme: () => dispatch(actionCreators.setTopbarTheme('Light')),

        setupProgramDetailsTopbar: (showTopbar, showProgramProgress, showModuleProgress) => dispatch(actionCreators.setupProgramDetailsTopbar(showTopbar, showProgramProgress, showModuleProgress)),
        setTopbarTheme: (theme) => dispatch(actionCreators.setTopbarTheme(theme)),

        onFailureDialogShow: (msg, btnLabel) => dispatch(actionCreators.onFailureDialogShow(msg, btnLabel)),
        onFailureDialogHide: () => dispatch(actionCreators.onFailureDialogHide()),
        onSuccessDialogShow: (msg, btnLabel) => dispatch(actionCreators.onSuccessDialogShow(msg, btnLabel)),
        onSuccessDialogHide: () => dispatch(actionCreators.onSuccessDialogHide()),

        redirectToUnauthorized: () => dispatch(actionCreators.redirectToUnauthorized()),
        redirectToNotFound: () => dispatch(actionCreators.redirectToNotFound()),
        redirectToServerError: () => dispatch(actionCreators.redirectToServerError()),
        showSessionExpiredDialog: (show) => dispatch(actionCreators.showSessionExpiredDialog(show))

    }
}

export default connect(mapStateToProps, mapDisptachToProps)(CustomerSupport);